import { TenantConfig } from '@/types/TenantConfig'

const red = '#F94538'
const blue = '#275EF4'
const white = '#F2F2F2'
const lightWhite = '#FAFAFA'

export const whynotyes: TenantConfig = {
  logo: 'assets/whynotyes/static/logo.png',
  themeOptions: {
    primaryColor: red,
    secondaryColor: blue,
    headerBackground: white,
    memberLinksColor: red,
    cartHeaderBackgroundColor: 'black',
    footerBackgroundColor: white,
    logoHeight: '80px',
    pageBackgroundColor: lightWhite,
    headerDropShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
  },
  componentOptions: {
    completedOrdersRoute: {
      completedContentOffset: {
        desktop: '80px',
        mobile: '50px',
      },
    },
  },
}
